import React from 'react'
import MenuNavStyle from '../styles/MenuNavStyle'
import { NAV_LINKS } from '../consts/navLinks'
const MenuNav = ({ handleScroll, functionsRef, pricesRef }) => {
  const links = NAV_LINKS
  return (
    <MenuNavStyle>
      <ul className="nav">
        {links.map(item => {
          return item.id === '1' ? (
            <li key={item.id}>
              <span
                onClick={() => {
                  handleScroll(functionsRef)
                }}
              >
                {item.title}
              </span>
            </li>
          ) : item.id === '2' ? (
            <li key={item.id}>
              <span
                onClick={() => {
                  handleScroll(pricesRef)
                }}
              >
                {item.title}
              </span>
            </li>
          ) : (
            <li key={item.id}>
              <a href={item.href}>{item.title}</a>
            </li>
          )
        })}
      </ul>
    </MenuNavStyle>
  )
}

export default MenuNav
